import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-orange-50 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-206" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-207" data-mp="30j0qr08ey70g">
        <div className="text-center" data-id="element-208" data-mp="2vpg2w10jatez">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-green-950 sm:text-4xl" data-id="element-209" data-mp="2voehp3pt0qjj">
            Does this sound familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-stone-900" data-id="element-210" data-mp="35fr7lps1l6mx">
            Sunday at 11 p.m. Tomorrow you have drilling and well engineering class. And you're still searching for the
            best way to explain well planning, drilling operations, casing and cementing, and the role of drilling
            engineering in modern well construction without losing your students' attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-stone-600" data-id="element-211" data-mp="1k5ap004rnutz">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-stone-200 bg-white p-6 shadow-sm sm:p-8" data-id="element-212" data-mp="x49uv69gfdov">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-green-950" data-id="element-213" data-mp="1c1j093vlehzl">
            <AlertTriangleIcon className="h-5 w-5 text-red-700" aria-hidden="true" data-id="element-214" data-mp="1g3w41mqs45tq" />
            The real cost of not having the right materials
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-215" data-mp="3dv8l60jrcq62">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-stone-600" data-id="element-216" data-mp="3hv0u4ed2cyby">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-700" aria-hidden="true" data-id="element-217" data-mp="p0isfizk5nmc" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-218" data-mp="y2i7i5r0ihmn">
          <p className="text-lg font-bold text-green-950" data-id="element-219" data-mp="tzll03ycq1df">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="mt-3 text-2xl font-extrabold text-stone-700 sm:text-3xl" data-id="element-220" data-mp="1301qtk2khklg">
            Plan your entire year today.
          </p>
        </div>
      </div>
    </section>;
}